var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReposition = function SvgReposition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.012 5 1.993 3h-1.528v3.5h3.533v-1.492l2.99 2-2.99 2V12.5h-3.533V16h1.528l-1.993 3-1.993-3h1.461v-3.5H8.03v1.504l-2.989-2 2.99-2L8.03 11.5h3.45V8h-1.46l1.992-3z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgReposition;